import { Col, Row } from "antd";
import { useEffect } from "react";
import { useLazyGetEventListQuery } from "../../event/redux/EventApi";
import NewsItem from "./NewsItem";

const HomeNews = () => {
    const [trigger, response] = useLazyGetEventListQuery();
    useEffect(() => {
        trigger({ page: 0, size: 6, status: 1, type: 1 })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <div className="responsive-padding-1440">
            <div className="home-news">
                <Row align="middle" gutter={[40, 20]}>
                    {response.data?.content.length ?
                        <>
                            {response?.data?.content?.map((item, index) => {
                                return <Col xl={8} xs={24} md={12} key={index}>
                                    <NewsItem item={item} />
                                </Col>
                            })}
                        </> :
                        <Col span={24}>
                            <div style={{ textAlign: 'center', fontSize: 22 }}>Hiện không có tin tức sự kiện</div>
                        </Col>}
                </Row>
            </div>
        </div>
    )
}

export default HomeNews;